<h1 mat-dialog-title i18n="@@technical-details-dialog.title">Additional information</h1>
<div mat-dialog-content>
  <div class="field-with-label">
    <div class="label" i18n="@@einvoice.technical.labels.invoice-type">Invoice type</div>
    <app-field [document]="document" path="InvoiceTypeCode.value" [i18nNamespace]="['UNCL1001-cn', 'UNCL1001-inv']" prefix="{{erechnungPrefix}}"></app-field>
  </div>
  <div class="field-with-label">
    <div class="label" i18n="@@einvoice.technical.labels.buyer-identifier">Buyer identifier</div>
    <app-field [document]="document.Buyer" path="BuyerLegalRegistrationIdentifier.value"></app-field>
  </div>
  <div class="field-with-label">
    <div class="label" i18n="@@einvoice.technical.labels.scheme-seller-reg-number">Scheme of the seller's registration number</div>
    <app-field [document]="document" path="Seller.SellerLegalRegistrationIdentifier.schemeID"></app-field>
  </div>
  <div class="field-with-label">
    <div class="label" i18n="@@einvoice.technical.labels.scheme-buyer-reg-number">Scheme of the buyer's registration number</div>
    <app-field [document]="document" path="Buyer.BuyerLegalRegistrationIdentifier.schemeID"></app-field>
  </div>
  <div class="field-with-label">
    <div class="label" i18n="@@einvoice.technical.labels.scheme-buyer-electronic-address">Scheme of the buyer's electronic address</div>
    <app-field [document]="document" path="Buyer.BuyerElectronicAddress.schemeID"></app-field>
  </div>
  <div class="field-with-label">
    <div class="label" i18n="@@einvoice.technical.labels.scheme-seller-electronic-address">Scheme of the seller's electronic address</div>
    <app-field [document]="document" path="Seller.SellerElectronicAddress.schemeID"></app-field>
  </div>
  <div class="field-with-label">
    <div class="label" i18n="@@einvoice.technical.labels.code-of-vat-currency">Code of the VAT currency</div>
    <app-field [document]="document" path="VATAccountingCurrencyCode.value"></app-field>
  </div>
  <div class="field-with-label">
    <div class="label" i18n="@@einvoice.technical.labels.identifier-of-justifying-document">Identifier of the document justifying the invoice</div>
    <app-field [document]="document" path="InvoicedObjectIdentifier.value"></app-field>
  </div>
  <div class="field-with-label">
    <div class="label" i18n="@@einvoice.technical.labels.process-identifier-of-contract">Process identifier of the contract</div>
    <app-field [document]="document" path="ProcessControl.BusinessProcessType.value"></app-field>
  </div>
  <div class="field-with-label">
    <div class="label" i18n="@@einvoice.technical.labels.spec-identifier-of-contract">Specification identifier of the contract</div>
    <app-field [document]="document" path="ProcessControl.SpecificationIdentifier.value"></app-field>
  </div>
  @if (format) {
    <div class="field-with-label">
      <div class="label" i18n="@@einvoice.technical.labels.format-name-version-syntax">Invoice</div>
      <app-field [directValue]="getFormatAsString()"></app-field>
    </div>
  }
</div>
<div mat-dialog-actions>
  <button mat-button color="primary" mat-dialog-close cdkFocusInitial i18n="@@technical-details-dialog.button.ok">Ok</button>
</div>
